import { createStorage } from "../../storage";
import createSendMetric from "./createSendMetric";

const TimeMetricHandler = (repository, key, scope) => {
  const sendMetric = createSendMetric(repository, scope);
  const storage = createStorage(repository, scope);
  return {
    start() {
      storage.set(key, Date.now());
    },
    end() {
      const timeEnd = Date.now();
      const timeInit = storage.get(key);
      const time = timeEnd - timeInit;

      storage.remove(key);
      if (timeInit) {
        sendMetric("trackTime", {
          key,
          time,
        });
      }
    },
  };
};

export default TimeMetricHandler;
